// ------- 乐园相关 --------
import fetch from "./http";

// 乐园基本信息
export function villageInfo() {
  return fetch({
    url: "/play/get-monster-park-info",
  });
}

// 获取游戏对应模式信息
export function villageGameModeInfo(params = {}) {
  return fetch({
    url: "/play/get-mode-info",
    params,
  });
}

// 获取PVP擂台挑战名单
export function villagePvpOpponentList(params = {}) {
  return fetch({
    url: "/play/get-pvp-challenge-list",
    params,
  });
}

// 开始游戏
export function villageStartGame(params = {}) {
  return fetch({
    url: "/play/start-game",
    type: "post",
    params,
    config: {
      type: "json",
      headers: { "Content-Type": "application/json" },
    },
  });
}

// 领奖
export function villageToPrize(params = {}) {
  return fetch({
    url: "/play/apply-bonus",
    params,
  });
}

// 趣味值排名
export function villageRankList() {
  return fetch({
    url: "/play/get-play-weekly-rank",
  });
}

// 获取商店信息
export function villageStoreList() {
  return fetch({
    url: "/play/get-store-info",
  });
}

// 勋章兑换
export function villageExchange(params) {
  return fetch({
    url: "/play/medal-exchange",
    type: "post",
    params,
    config: {
      type: "json",
      headers: { "Content-Type": "application/json" },
    },
  });
}

// 领取趣味值周奖励
export function villageRankReward() {
  return fetch({
    url: "/play/get-play-weekly-rank-reward",
  });
}

// 放弃未完成的游戏
export function villageAbandonGame(params) {
  return fetch({
    url: "/play/abandon-game",
    params,
  });
}
